import React from 'react';
import {useTranslation} from 'react-i18next';

import {DefaultTheme} from 'styled-components';

import {ECurrency, formatMoney, markSearchText} from '@edna/utils';

import {TSize} from '../types';
import * as S from './style';

export type TProps = {
  value?: number;
  size?: TSize;
  className?: string;
  currency?: keyof typeof ECurrency;
  fractionDigitsCount?: number;
  color?: keyof DefaultTheme['palette'];
  currencyComponent?: TAnyComponent;
};

const CURRENCY_REGEXP = new RegExp(/[^0-9,.\s-]/);

const Price = React.memo<TProps>(
  ({
    className,
    value,
    currency = ECurrency.RUB,
    color = 'black',
    size = 'L',
    fractionDigitsCount,
    currencyComponent = S.Currency,
  }) => {
    const {
      i18n: {language},
    } = useTranslation();

    if (value === undefined) {
      return null;
    }

    const formattedValue = formatMoney({
      amount: value,
      currency,
      fractionDigitsCount,
      language,
    }).replace('-', '- ');

    return (
      <S.Price className={className} color={color} size={size}>
        {markSearchText(currencyComponent, formattedValue, CURRENCY_REGEXP)}
      </S.Price>
    );
  },
);

export default Price;
